"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Warning = _interopRequireDefault(require("@material-ui/icons/Warning"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _RemoveRedEye = _interopRequireDefault(require("@material-ui/icons/RemoveRedEye"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

var _StatusDate = _interopRequireDefault(require("./StatusDate"));

require("./NavStatus.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  icon: {},
  statusLabel: {
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "bold",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  statusDate: {
    fontFamily: "Akkurat, sans-serif",
    marginRight: theme.spacing(1)
  }
}));

const NavStatus = ({
  className,
  status = "new",
  statusLabel,
  statusMessage,
  statusDate
}) => {
  const classes = useStyles();

  let icon = _react.default.createElement(_RemoveRedEye.default, null);

  if (status === "trash") {
    icon = _react.default.createElement(_Delete.default, null);
  }

  if (status === "error") {
    icon = _react.default.createElement(_Warning.default, null);
  }

  return _react.default.createElement("nav", {
    className: className || classes.root
  }, _react.default.createElement(_IconButton.default, {
    className: classes.icon,
    size: "small"
  }, icon), _react.default.createElement("strong", {
    className: classes.statusLabel
  }, statusLabel || status), statusDate && _react.default.createElement(_StatusDate.default, {
    className: classes.statusDate
  }, statusDate), statusMessage && _react.default.createElement("span", {
    className: classes.statusMessage
  }, statusMessage));
};

var _default = NavStatus;
exports.default = _default;
module.exports = exports.default;